// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Section-module--cls1--1P3d-","cls2":"styles-Section-module--cls2--2Z2SC styles-Section-module--cls1--1P3d-"};